export default [
  {
    path: "/login",
    redirect: "/signin",
  },
  {
    path: "/signin",
    component: () => import("@/views/reports/signin/SignIn.vue"),
  },
  {
    path: "/signin/forgot",
    component: () => import("@/views/reports/signin/ForgotPassword.vue"),
  },
  {
    path: "/signin/reset",
    name: "reset-password",
    component: () => import("@/views/reports/signin/ResetPassword.vue"),
  },
  {
    path: "/signin/sso/redirect",
    component: () => import("@/views/reports/signin/SSORedirect.vue"),
  },
];
